let previousScroll = 0;
let scrollDirection = 'down';
const mainHeader = document.querySelector('.main-header');

const pageScroll = () => {
	if (window.pageYOffset <= 0) {
		document.body.classList.add('at-top');
	} else {
		document.body.classList.remove('at-top');
	}

	if (window.pageYOffset > previousScroll) {
		if (window.pageYOffset > 0) {
			document.body.classList.add('scrolled-down');
		}

		if (
			window.pageYOffset >= 200 &&
			!document.body.classList.contains('nav-dark-mode')
		) {
			if (mainHeader) {
				const mainHeaderBottom =
					mainHeader.getBoundingClientRect().bottom;

				if (mainHeaderBottom <= 0) {
					document.body.classList.add('nav-dark-mode');
				}
			}
		}

		if ('up' === scrollDirection) {
			document.body.classList.remove('scrolled-up');
		}

		scrollDirection = 'down';
	} else {
		if (window.pageYOffset === 0) {
			document.body.classList.remove('scrolled-down', 'scrolled-up');
		}

		if (window.pageYOffset < 200) {
			document.body.classList.remove('nav-dark-mode');
		}

		if ('down' === scrollDirection) {
			document.body.classList.remove('scrolled-down');
			document.body.classList.add('scrolled-up');

			if (!document.body.classList.contains('nav-dark-mode')) {
				document.body.classList.add('nav-dark-mode');
			}
		}

		scrollDirection = 'up';
	}

	previousScroll = window.pageYOffset <= 0 ? 0 : window.pageYOffset;
};

export default pageScroll;
